import { NgModule } from '@angular/core';

import {
  RouterModule,
  Routes
} from '@angular/router';

import {
  AuthGuard
} from './core/auth/auth.guard';

import {
  FirstLoginPasswordGuard
} from './core/guard/first-login-password.guard';
import { PermissionGuard } from './core/guard/permission-route.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },

  {
    path: 'login',
    loadChildren: () =>
      import(
        './login/login-module'
      ).then(
        module =>
          module.LoginModule
      )
  },

  {
    path: 'first-login-password',
    canActivate: [
      FirstLoginPasswordGuard
    ],
    loadChildren: () =>
      import(
        './modules/first-login-password/first-login-password-module'
      ).then(
        module =>
          module.FirstLoginPasswordModule
      )
  },

  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/dashboard/dashboard-module'
      ).then(
        module =>
          module.DashboardModule
      )
  },

  {
    path: 'candidates',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/candidates/candidates-module'
      ).then(
        module =>
          module.CandidatesModule
      )
  },

  {
    path: 'jobPosition',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/job-position/job-position-module'
      ).then(
        module =>
          module.JobPositionModule
      )
  },

  {
    path: 'recruiters',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/recruiters/recruiters-module'
      ).then(
        module =>
          module.RecruitersModule
      )
  },

  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/profile/profile-module'
      ).then(
        module =>
          module.ProfileModule
      )
  },

  {
    path: 'reset-password',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/reset-password/reset-password-module'
      ).then(
        module =>
          module.ResetPasswordModule
      )
  },

  {
    path: 'job-ingestion',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/job-ingestion/job-ingestion-module'
      ).then(
        module =>
          module.JobIngestionModule
      )
  },

  {
    path: 'recruiter-chat',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/rc-chat/rc-chat-module'
      ).then(
        module =>
          module.RcChatModule
      )
  },

  {
    path: 'user-management',
    canMatch: [AuthGuard, PermissionGuard],
    canActivate: [AuthGuard, PermissionGuard],
    data: {permissions: ['USERS_LIST'], accessMode: 'any'},
    loadChildren: () =>
      import(
        './modules/user-management/user-management-module'
      ).then(
        module =>
          module.UserManagementModule
      )
  },

  {
    path: 'menu',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/menu/menu-module'
      ).then(
        module =>
          module.MenuModule
      )
  },

  {
    path: 'roles',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/roles/roles-module'
      ).then(
        module =>
          module.RolesModule
      )
  },

  {
    path: 'permissions',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/permissions/permissions-module'
      ).then(
        module =>
          module.PermissionsModule
      )
  },

  {
    path: 'group-permissions',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/group-permission/group-permission-module'
      ).then(
        module =>
          module.GroupPermissionModule
      )
  },

  {
    path: 'role-permissions',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/role-permission/role-permission-module'
      ).then(
        module =>
          module.RolePermissionModule
      )
  },

  {
    path: 'groups',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/groups/groups-module'
      ).then(
        module =>
          module.GroupsModule
      )
  },

  {
    path: 'interviews',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/interviews/interviews-module'
      ).then(
        module =>
          module.InterviewsModule
      )
  },

  {
    path: 'page-not-found',
    loadChildren: () =>
      import(
        './modules/page-not-found/page-not-found-module'
      ).then(
        module =>
          module.PageNotFoundModule
      )
  },

  {
    path: 'mail-template',
    loadChildren: () =>
      import('./modules/mail-template/mail-template.module')
        .then(module => module.MailTemplateModule)
  },
  
  {
    path: 'configuration-settings',
    loadChildren: () =>
      import('./modules/configuration-settings/configuration-settings.module')
        .then(m => m.ConfigurationSettingsModule)
  },

  {
    path: '**',
    redirectTo: 'page-not-found'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        scrollPositionRestoration:
          'top'
      }
    )
  ],

  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }